var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampingTent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6604 22.8549C23.5298 23.098 23.2761 23.2499 23 23.25H1C0.723907 23.2499 0.470215 23.098 0.339615 22.8549C0.209 22.6116 0.222595 22.3163 0.375 22.0861L10.766 6.02307C10.8768 5.85571 10.8768 5.63831 10.766 5.47107L8.666 2.30005C8.39137 1.8407 8.52699 1.24658 8.97374 0.952026C9.42047 0.657349 10.02 0.766724 10.334 1.20007L11.583 3.08398C11.6756 3.224 11.8322 3.30811 12 3.30811C12.1678 3.30811 12.3244 3.224 12.417 3.08398L13.665 1.203C13.979 0.769653 14.5785 0.6604 15.0253 0.954956C15.472 1.24963 15.6076 1.84375 15.333 2.30298L13.233 5.474C13.1222 5.64136 13.1222 5.85864 13.233 6.026L23.625 22.0861C23.7774 22.3163 23.791 22.6116 23.6604 22.8549ZM12 8.75C11.7239 8.75 11.5 8.97388 11.5 9.25V21.25C11.5 21.5261 11.7239 21.75 12 21.75H15.5C15.691 21.7501 15.8654 21.6414 15.9494 21.4698C16.0334 21.2982 16.0123 21.0938 15.895 20.943L12.605 16.714C12.5368 16.6262 12.4999 16.5182 12.5 16.407V9.25C12.5 8.97388 12.2761 8.75 12 8.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampingTent);
export default __webpack_public_path__ + "static/media/campingTent.e94383ba.svg";
export { ForwardRef as ReactComponent };